export const GRAPHQL_BASE_URL =
  process.env.REACT_APP_GRAPHQL_BASE_URL ||
  'https://lixinft-be.rover.cohost.tech/graphql';

export const BASE_URL =
  process.env.REACT_APP_BASE_URL || 'https://testnet.lixinft.cohost.ai';

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://lixinft-be.rover.cohost.tech';

export const TEMPLATE_ID =
  process.env.REACT_APP_TEMPLATE_ID || '61ee4f50081e4d196ba80130';

export const LIXI_BAG =
  process.env.REACT_APP_LIXI_BAG ||
  '0x86ef1194B5aCe8C26351B55BE17C5f5c42B025F2';

export const LIXI_NFT =
  process.env.REACT_APP_GRAPHQL_LIXI_NFT ||
  '0x971F8FdB8F5c160C791AB86B9e047e0503A6C273';

export const IS_STAGING = process.env.REACT_APP_IS_STAGING || 'true';

export const BSC_SCAN =
  IS_STAGING === 'true'
    ? 'https://testnet.bscscan.com/'
    : 'https://bscscan.com/';

export const GLOBAL_JACKPOT_CAMPAIGN_ID =
  IS_STAGING === 'true'
    ? '620f49bc89d60c001c721213'
    : '62146eb20edc4f2808fabda5';

export const WINNING_HASH =
  process.env.REACT_APP_WINNING_HASH || IS_STAGING === 'true'
    ? '0x83ae0e03f041d22b318722d57fd0df04a3f5bbbfc54bdbe9bddb4d91f94dcbd1'
    : '0xb8dc9719d70cec6ad0d50d87e70dad8aefca674364895dd19ff80049a1894bfd';

export const GAS_PRICE = parseFloat(process.env.REACT_APP_GAS_PRICE || '0.002');

export const BLOG_URL =
  process.env.REACT_APP_BLOG_URL || 'https://blog.lixinft.me/';

// Solana Configuration
export const SOLANA_RPC_URL =
  process.env.REACT_APP_SOLANA_RPC_URL || 'https://api.devnet.solana.com';

export const SOLANA_PROGRAM_ID =
  process.env.REACT_APP_SOLANA_PROGRAM_ID ||
  '5QUDoty9HumNt3GenQyXqwpdDMUd7hmJuRLNkvJekf4Q';

export const SOLANA_CLUSTER = process.env.REACT_APP_SOLANA_CLUSTER || 'devnet';

export const SOLANA_AUTHORITY =
  process.env.REACT_APP_SOLANA_AUTHORITY ||
  'EGdnvoDGQNTrpkf69uxKK9dJBshwSzBRxYmv2kw4jfP1';

// Chain Selection
export const DEFAULT_CHAIN = process.env.REACT_APP_DEFAULT_CHAIN || 'bnb';

// Supported Chains
export const SUPPORTED_CHAINS = ['bnb', 'solana'] as const;
export type SupportedChain = (typeof SUPPORTED_CHAINS)[number];
